// src/components/ui/LandingButton.jsx
import React from "react";

const cx = (...classes) => classes.filter(Boolean).join(" ");

function LandingButton({
  children,
  variant = "primary",
  className = "",
  type = "button",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center rounded-full px-6 py-3 text-sm sm:text-base font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400";

  const variants = {
    primary:
      "bg-sky-500 text-white shadow-lg shadow-sky-500/20 hover:bg-sky-600",
    secondary:
      "border border-slate-300 bg-white text-slate-900 hover:bg-slate-50",
    dark: "bg-slate-900 text-white hover:bg-slate-800",
  };

  return (
    <button
      type={type}
      className={cx(base, variants[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
}

export default LandingButton;